module.exports = __webpack_public_path__ + "img/bg.a73c4619.png";